import { apiSlice } from "app/api/apiSlice";

export const passwordRecoveryApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    requestRecoveryCode: builder.mutation({
      query: payload => ({
        url: "/bouser/auth/recoverpassword",      
        method: 'PUT',
        body: { ...payload },
      }),
    }),
  }),
  overrideExisting: true,
})

export const {
  useRequestRecoveryCodeMutation,
} = passwordRecoveryApiSlice